import { PRODUCT_CARD_VARIANT } from '~/utils/productCardVariant'

/** Which product card to render: V2 or the previous `ProductCard` (control). */
export const useProductCardVariant = () => ({
  variant: PRODUCT_CARD_VARIANT,
  isV2: PRODUCT_CARD_VARIANT.variant === 'v2',
})
